<template>
  <v-container fluid tag="section" :class="item.show ? '' : 'py-0'">
    <base-material-dialog
      :title='item.data === undefined ? "重新申报" : "重新申报" '
      :dialog="item.show"
      @on-dialog-change='dialogChange'
      persistent
      max-width='500'
    >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-alert colored-border color="deep-purple accent-4" elevation="2">
                  <div class="my-1">{{item.data.customer.name}}</div>
                  <div class="my-1">{{item.data.serialNumber}}</div>
                  <div class="my-1"> {{item.data.product.name}}</div>
                </v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                 <v-select
                  :items="yearItems"
                  label="项目年度"
                  v-model="form.year"
                  outlined
                  item-text='label'
                  :rules="required"
                  hide-details='auto'
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                    :items="orderUrgentLevelItems"
                    label="紧急程度"
                    v-model="form.urgentLevelId"
                    outlined
                    item-text='name'
                    item-value="id"
                    :rules="required"
                    hide-details='auto'
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea outlined  rows='3' v-model="form.orderRemark" label="备注"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" rounded :loading="loading" @click='save'>
              保存&发工单
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { getByPids } from '@/api/system/dictionary.js'
  import { again } from '@/api/contract/index.js'
  import { selectNextYear } from '@/utils/tool.js'

  export default {
    name: 'Again',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null,
        })
      }
    },
    data() {
      return {
        loading: false,
        laterPrice: 0,
        required: [
          value => !!value || '此项为必填项!'
        ],
        yearItems: selectNextYear(),
        form: {
          id: '',
          year: '',
          urgentLevelId: '',
          orderRemark: ''
        },
        orderUrgentLevelItems: []
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          again(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form = JSON.parse(JSON.stringify(this.item.data))
          }
        }
      },
      getTypes () {
        getByPids(
          {
            pids: [
              this.$constants.orderUrgentLevelPid
            ]
          }
        ).then(res => {
          if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
              if (this_.$constants.orderUrgentLevelPid === result.id) {
                this_.orderUrgentLevelItems = result.data
              }
           })
          }
        })
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data !== null
      }
    },
    created() {
      this.getTypes()
    }
  }
</script>

<style>
</style>
